<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Opportunity Field</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <!-- <vs-button
              @click="editOpportunityField"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            > -->
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />
        <div class="vx-row p-5" v-if="opportunityFieldDescription.company_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Opportunity:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ opportunityFieldDescription.company_name }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="opportunityFieldDescription.name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ opportunityFieldDescription.name }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="opportunityFieldDescription.description">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Description:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ opportunityFieldDescription.description }}
          </div>
        </div>
           
        <div class="vx-row p-5" v-if="opportunityFieldDescription.type">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             Type:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ opportunityFieldDescription.type }}
          </div>
        </div>
        <!-- <div class="vx-row p-5" v-if="opportunityFieldDescription.values">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             Value:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ JSON.parse(opportunityFieldDescription.values) }}
          </div>
        </div> -->
        <div class="vx-row p-5" v-if="opportunityFieldDescription.type">
          <div class="vx-col sm:w-1/5 w-full">
             
          </div>
          <span><b>
              Example :
           </b> </span>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="opportunityFieldDescription.type == 'text'"
          >
            <vs-input class="w-full" name="name" />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="opportunityFieldDescription.type == 'number'"
          >
            <vs-input class="w-full" name="name" type="number" />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="opportunityFieldDescription.type == 'textarea'"
          >
            <vs-textarea v-model="textarea" />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="opportunityFieldDescription.type == 'date'"
          >
             <flat-pickr
                      :config="configDateTimePicker"
                      placeholder="Choose Date"
                      name="continuous_date_end"
                    />
          </div>
            <div
            class="vx-col sm:w-1/3 w-full"
            v-if="opportunityFieldDescription.type == 'datetime'"
          >
             <flat-pickr
                      :config="configDateAndTimePicker"
                      placeholder="Choose Date And Time"
                      name="continuous_date_and_time"
                    />
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="opportunityFieldDescription.type == 'checkbox'"
          >
            <span
              v-for="v in JSON.parse(opportunityFieldDescription.values)"
              class="p-2"
            >
              <vs-checkbox class="mr-2">{{ v.value }}</vs-checkbox>
            </span>
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="opportunityFieldDescription.type == 'dropdown'"
          >
            <v-select
              label="value"
              :options="JSON.parse(opportunityFieldDescription.values)"
              name="type"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="opportunityFieldDescription.type == 'choose_one'"
          >
          <!-- {{opportunityFieldDescription.values}} -->
            <span
              v-for="v in JSON.parse(opportunityFieldDescription.values)"
              class="p-2"
            >
              <vs-radio vs-name="radios1" vs-value="luis" class="mr-2">{{
                v.value
              }}</vs-radio>
            </span>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import defineAbilitiesFor from "@/config/abilities";
import _ from "lodash";
import moduleOpportunityFieldsManagement from "@/store/fields-management/opportunity-fields-management/moduleOpportunityFieldsManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
      configDateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
  configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
      abilities: null,
      opportunityFieldDescription: [],
      fieldId: null
    };
  },
  components: {
    "v-select": vSelect,
    moduleOpportunityFieldsManagement,
        flatPickr

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleOpportunityFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "OpportunityFieldsManagement",
        moduleOpportunityFieldsManagement
      );
      moduleOpportunityFieldsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fieldId = this.$route.params.fieldId;
    this.fetchOpportunityField();
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    fetchOpportunityField() {
      this.$store
        .dispatch("OpportunityFieldsManagement/fetchFields", this.fieldId)
        .then(res => {
          let result = JSON.parse(res.data);
          this.opportunityFieldDescription = result[0]
          // console.log(this.opportunityFieldDescription[0])
        })
        .catch(err => {
          console.error(err);
        });
    },
    editOpportunityField() {
      this.$router.push({ path: `/fields/opportunity-field/edit/${this.fieldId}` });
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
